import React, {useEffect, useState} from "react";
import {Button, Col, Form, Image, Input as AntInput, Input, Row, Select, Space, Table, Upload} from "antd";
import axios from "axios";
import {getChargePointBasedOnTextSearchResponse, getUsersResponse} from "../../../types/admin";
import {useCredentialStore} from "../../../hooks/useCredentialsStore";
import {useNavigate, useParams} from "react-router-dom";
import {PopNotification} from "../../../shared/notification";

export const MessageDetailsPage = () => {
    const { id } = useParams();

    const navigate = useNavigate();

    const [form] = Form.useForm();
    const [name, setName] = useState()
    const [events, setEvents] = useState<any[]>([])
    const [channels, setChannels] = useState<any[]>([])
    const [selectedEvent, setSelectedEvent] = useState<any>()
    const [selectedEventData, setSelectedEventData] = useState<any>()
    const [selectedChannel, setSelectedChannel] = useState<any>()
    const [targets, setTargets] = useState<any[]>([])
    const [selectedTarget, setSelectedTarget] = useState()
    const [channelConfigData, setChannelConfigData] = useState<any>({})
    const [tested, setTested] = useState(false)

    const {token} = useCredentialStore(({token}) => ({
        token
    }));

    useEffect(() => {
        handleGetEvents()
        handleGetChannels()
    }, []);

    useEffect(() => {
        if (id) {
            handleGetMessage(id)
        }
    }, [id]);

    useEffect(() => {
        if (!selectedEvent) {
            return;
        }

        if (selectedEvent === 'CHARGE_POINT_CHARGER_ONLINE_EVENT') {
            handleGetChargePoints()
        } else if (selectedEvent === 'CHARGER_ONLINE_EVENT') {
            handleGetChargers()
        }

    }, [selectedEvent]);

    useEffect(() => {
        if (events.length > 0 && selectedEvent) {
            setSelectedEventData(events.filter(x => x.code === selectedEvent)[0])
        }
    }, [selectedEvent, events])

    useEffect(() => {
        setChannelConfigData({})
    }, [selectedChannel]);

    const handleGetMessage = (data: string) => {
        axios
            .get(`/api/message/${data}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                const resData = res.data;
                console.log(resData)
                setName(resData.name)
                setSelectedChannel(resData.channel)
                setSelectedEvent(resData.event)
                setChannelConfigData(JSON.parse(resData.configJson))
                setSelectedTarget(resData.targetId)
            })
            .catch((error) => {
                PopNotification("error", error || error?.response?.data?.message || `Something went wrong, ${error.toString()}`);
            })
            .finally(() => {
            });
    };

    const handleGetEvents = () => {
        axios
            .get(`/api/message/event`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                setEvents(res.data)
            })
            .catch((error) => {
                PopNotification("error", error || error?.response?.data?.message || `Something went wrong, ${error.toString()}`);
            })
            .finally(() => {
            });
    };

    const handleGetChannels = () => {
        axios
            .get(`/api/message/channel`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                setChannels(res.data)
            })
            .catch((error) => {
                PopNotification("error", error || error?.response?.data?.message || `Something went wrong, ${error.toString()}`);
            })
            .finally(() => {
            });
    };

    const handleGetChargers = () => {
        axios
            .get(`/api/chargers?page=0&pageSize=200`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                const chargePointList: getChargePointBasedOnTextSearchResponse = res.data;
                setTargets(chargePointList.data);
            })
            .catch((error) => {
                PopNotification("error", error.response.data.message);
            })
    }

    const handleGetChargePoints = () => {
        axios
            .get(`/api/chargePoints?page=0&pageSize=200`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                const chargePointList: getChargePointBasedOnTextSearchResponse = res.data;
                setTargets(chargePointList.data);
            })
            .catch((error) => {
                PopNotification("error", error.response.data.message);
            })
    }


    const handleTestChannel = () => {
        axios
            .post(`/api/message/channel/test`, {
                channel: selectedChannel,
                configJson: JSON.stringify(channelConfigData)
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                setTested(true)

            })
            .catch((error) => {
                setTested(false)
                PopNotification("error", error.response.data.message);
            })
    }


    const handleSaveMessage = () => {

        axios
            .post(`/api/message`, {
                name: form.getFieldValue("name"),
                event: selectedEvent.code,
                targetId: selectedTarget,
                channel: selectedChannel,
                configJson: JSON.stringify(channelConfigData)
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((res) => {
                PopNotification("success", "Create message success!");
                navigate("/admin/messaging");
            })
            .catch((error) => {
                PopNotification("error", error.response.data.message);
            })
    }

    const renderEventData = (event: any) => {
        if (!event || !event?.code) {
            return <></>
        }

        console.log(targets)

        if (event.code === 'CHARGE_POINT_CHARGER_ONLINE_EVENT') {

            return <>
                <div>
                   <span>Charge Point: </span>
                    <span>{targets.filter(x => x.id.id === selectedTarget).map(x => x.name)[0]}</span>
                </div>

            </>
        } else if (event.code === 'CHARGER_ONLINE_EVENT') {


            return <>
                <span>Charger: </span>
                <span>{targets.filter(x => x.id.id === selectedTarget).map(x => x.uniqueId)[0]}</span>
            </>
        } else {
            return <span></span>
        }
    }

    const renderChannelConfigData = () => {
        if (selectedChannel === 'telegramMessageChannel') {
            return <>
                <div>
                    <span>Token: </span>
                    <span>{channelConfigData.token}</span>
                </div>
                <div>
                    <span>Chat Id: </span>
                    <span>{channelConfigData.chatId}</span>
                </div>
                <div>
                    <span>Uptime Debounce: </span>
                    <span>{channelConfigData.uptimeDebounce}</span>
                </div>
                <div>
                    <span>Downtime Debounce: </span>
                    <span>{channelConfigData.downtimeDebounce}</span>
                </div>
            </>
        }
    }

    return (
        <Space direction={"vertical"} style={{width: '100%'}}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span className='page-title'>Message Details</span>

            </div>

            <Form form={form}
                  layout="vertical"
            >
                <div>
                    <div>
                        <span>Name: </span>
                        <span>{name}</span>
                    </div>
                    <span className='id-css'>Event</span>
                    <div>
                        <span>Event: </span>
                        <span>{selectedEventData?.name}</span>
                    </div>
                    {selectedEvent && renderEventData(selectedEventData)}
                    {selectedEvent && <>
                        <div>
                            <div>
                                <span>Description: </span>
                                <span>{selectedEventData?.description}</span>
                            </div>

                            <div>
                                <span>Example: </span>
                                <span>{selectedEventData?.sample}</span>
                            </div>
                        </div>
                    </>

                    }
                    <span className='id-css'>Channel</span>
                    <div>
                       <span>Channel: </span>
                        <span>{selectedChannel}</span>
                    </div>
                    {selectedChannel && renderChannelConfigData()}

                </div>

            </Form>
        </Space>
    )
}
